export const getIsLocked = (self, el) => {
  const locking = self._getLockingThrowable();
  return locking.getIsLocked(el);
};
